import { render, staticRenderFns } from "./selectMyCoins.vue?vue&type=template&id=56519768&scoped=true"
import script from "./selectMyCoins.vue?vue&type=script&lang=js"
export * from "./selectMyCoins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56519768",
  null
  
)

export default component.exports